import { InjectionToken } from '@angular/core';

export const PERMISSION = new InjectionToken<object>('PERMISSION');
